import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { clearSentryUser, setSentryContext, setSentryTag, setSentryUser } from "./index";

const buildIdentityKey = (user) =>
  user ? [user.cognito_user_id || user.userId || user.id || "", user.email || "", user.username || ""].join("|") : "";

function SentryTracker() {
  const user = useSelector((state) => state?.user);
  const location = useLocation();
  const lastIdentityRef = useRef("");
  const lastRouteRef = useRef("");

  useEffect(() => {
    const identityKey = buildIdentityKey(user);
    if (!identityKey) {
      if (lastIdentityRef.current) clearSentryUser();
      lastIdentityRef.current = "";
      return;
    }
    if (lastIdentityRef.current !== identityKey) {
      setSentryUser(user);
      lastIdentityRef.current = identityKey;
    }
  }, [user]);

  useEffect(() => {
    const routeKey = `${location.pathname}${location.search}${location.hash}`;
    if (lastRouteRef.current === routeKey) return;
    lastRouteRef.current = routeKey;
    setSentryTag("route", location.pathname);
    const routeAppId = location.pathname.match(/^\/dashboard\/(1|2)(?:\/|$)/)?.[1];
    setSentryTag("app_id", routeAppId || process.env.REACT_APP_APP_ID || "home");
    setSentryContext("route", { pathname: location.pathname, search: location.search || undefined, hash: location.hash || undefined });
  }, [location.hash, location.pathname, location.search]);

  return null;
}

export default SentryTracker;
